module.exports = __webpack_public_path__ + "img/commentSuccess.9d82f5f4.png";